<template>
  <div class="main">
    <Breadcrumb
      class="breadcrumb"
      separator="<span style='color:#515a6e'>></span>"
    >
      <BreadcrumbItem to="/"
        ><span style="color: #2849bc">{{
          $t("menu.home")
        }}</span></BreadcrumbItem
      >
      <BreadcrumbItem>{{ $t("hash.tit") }}</BreadcrumbItem>
    </Breadcrumb>
    <div class="info">
      <div class="body">
        <div class="tit">{{ $t("hash.tit") }}： {{ $route.query.hash }}</div>
        <div class="flexdiv">
          <table style="border-color: red">
            <tr>
              <td>
                <span>{{ $t("hash.list")[0] }}</span>
                <span class="value">{{ getTradeType(info.type) }} </span>
              </td>
            </tr>
            <tr>
              <td>
                <span>{{ $t("hash.list")[1] }}</span>
                <span
                  class="err"
                  @click="$router.push(`/account?address=${info.account}`)"
                  style="cursor: pointer"
                  >{{ info.account }}</span
                >
              </td>
            </tr>
            <tr>
              <td>
               <span v-if="!isContract">{{ $t("hash.list")[2] }}</span>
              <span v-else>{{ $t("hash.contractAddress") }}</span>
                <span
                  v-if="info.destination"
                  class="err"
                  @click="$router.push(`/account?address=${info.destination}`)"
                  style="cursor: pointer"
                  >{{ info.destination }}</span
                >
                <span v-else>--</span>
              </td>
            </tr>
            <tr>
              <td>
                <span>{{
                  info.type == "AccountSet"
                    ? $t("hash.text")[0]
                    : info.type == "TrustSet"
                    ? $t("hash.text")[1]
                    : $t("hash.list")[5]
                }}</span>
                <span class="value">
                  {{
                    info.type == "AccountSet"
                      ? info.setFlag == 4
                        ? "SetFlag=4(" + $t("disableSecret") + ")"
                        : info.setFlag == 8
                        ? "SetFlag=8(" + $t("defaultSpread") + ")"
                        : info.clearFlag == 4
                        ? "ClearFlag=4(" + $t("enableSecret") + ")"
                        : info.clearFlag == 8
                        ? "ClearFlag=8(" + $t("defaultNoSpread") + ")"
                        : info.setFlag || info.clearFlag
                      : info.amount || "--"
                  }}</span
                >
              </td>
            </tr>
            <tr v-if="!isContract" style="word-break: break-all">
              <td>
                <span>{{ $t("hash.list")[9] }}</span>
                <span class="value">
                  <template v-for="item in info.amountObjs">
                    <div v-if="item.issuer || item.counterparty">
                      <span style="padding-right: 5px"
                        >{{ item.currency }}:</span
                      >
                      <span v-if="item.issuer">{{ item.issuer }}</span>
                      <span v-else="item.counterparty">{{
                        item.counterparty
                      }}</span>
                    </div>
                    <div v-else>--</div>
                  </template>
                  {{ !info.amountObjs ? "--" : "" }}
                </span>
              </td>
            </tr>
            <tr v-if="isContract">
              <td>
                <span>{{ $t("hash.contractMethod") }}</span>
                <span v-if="info.contractMethod" class>
                  {{ info.contractMethod }}
                </span>
                <span v-else>--</span>
              </td>
            </tr>
            <tr v-if="isContract">
              <td>
                <span>{{ $t("hash.codeAddress") }}</span>
                <span
                  v-if="info.codeAddress"
                  class="err"
                  @click="$router.push(`/contract_info/${info.codeAddress}`)"
                  style="cursor: pointer"
                  >{{ info.codeAddressStr }}</span
                >
                <span v-else>--</span>
              </td>
            </tr>
          </table>
          <table>
            <tr>
              <td>
                <span>{{ $t("hash.list")[4] }}</span>
                <span
                  v-html="
                    info.result == 'tesSUCCESS'
                      ? `<span class = \'success\' >${$t('success')}</span>`
                      : !info.hasOwnProperty('result')
                      ? ''
                      : `<span class=\'error\'>${$t('error')}</span>`
                  "
                ></span>
              </td>
            </tr>
            <tr>
              <td>
                <span>{{ $t("hash.list")[3] }}</span>
                <span class="value">{{ info.ledger }}</span>
              </td>
            </tr>
            <tr>
              <td>
                <span>{{ $t("hash.list")[6] }}</span>
                <span class="value">{{ info.fee }} {{ $config.currency }}</span>
              </td>
            </tr>
            <tr>
              <td>
                <span>{{ $t("hash.list")[7] }}</span>
                <span class="value">{{ info.time }}</span>
              </td>
            </tr>
             <tr v-if="isContract">
            <td>
              <span>{{ $t("hash.codeVersion") }}</span>
              <span v-if="info.codeType" class>{{ info.codeType+' '+info.codeVersion }}</span>
              <span v-else>--</span>
            </td>
          </tr>
          <tr v-if="isContract">
            <td style="height: 50px; border-bottom: 0px !important">
              <span></span>
              <span></span>
            </td>
          </tr>
          </table>
        </div>
        <div class="beizhu">
          <span>{{memoTitle }}</span>
          <div class="remark-body" v-if="transformData">
            <pre
              v-highlightjs="transformData"
              style="text-align: left; word-wrap: break-all"
            >
              <code>
              </code>
            </pre>
          </div>
          <div class="remark-body" style="color: #0b0b0b" v-else>
            <template v-for="item in info.simple_memos">
              {{ item.memo_data }}
            </template>
            {{ !info.simple_memos ? "--" : "" }}
          </div>
        </div>
      </div>
    </div>

    <div class="result">
      <div class="h3" style="font-size: 14px">{{ $t("hash.tit2") }}</div>
      <template v-if="info.txResults && info.txResults.length">
        <div v-if="info.type == 'SignerListSet'">
          <p v-if="info.result != 'tesSUCCESS'">{{ info.txResults[0] }}</p>
          <table>
            <tr>
              <td>{{ $t("signerQuorum") }}:</td>
              <td style="padding-left: 10px">
                {{ info.txResults[0].signerQuorum }}
              </td>
            </tr>
            <tr
              v-for="(item, index) in info.txResults[0].signerList"
              :key="index"
            >
              <td>{{ index == 0 ? $t("signerList") + ":" : "" }}</td>
              <td style="padding-left: 10px">
                {{ item.SignerEntry.Account }}[
                {{ item.SignerEntry.SignerWeight }} ]
              </td>
            </tr>
          </table>
        </div>
        <div v-else-if="info.type == 'Payment' && info.signerList">
          <p v-if="info.result != 'tesSUCCESS'">{{ info.txResults[0] }}</p>
          <table>
            <tr v-for="(item, index) in info.signerList" :key="index">
              <td>{{ index == 0 ? $t("signerList") + ":" : "" }}</td>
              <td style="padding-left: 10px">{{ item.Signer.Account }}</td>
            </tr>
          </table>
        </div>
        <div v-else>
          <p v-for="(item, index) in info.txResults" :key="index">{{ item }}</p>
        </div>
      </template>

      <span
        v-if="info.txResults && !info.txResults.length"
        style="color: #0b0b0b"
        >{{ $t("nothing") }}</span
      >
    </div>
  </div>
</template>

<script>
import { Breadcrumb, BreadcrumbItem } from "iview";
import api from "../common/api";
import dayjs from "dayjs";
import { js_beautify } from "../common/lib/beautify.js";
import { formatJson } from "../common/lib/tojson.js";
import "../common/lib/beautify-tests.js";
import "../common/lib/HTML-Beautify.js";
export default {
  name: "Hash",
  components: {
    Breadcrumb,
    BreadcrumbItem,
  },
  data() {
    return {
      loading: false,
      isContract: false,
      memoTitle:this.$t("hash.list")[8],
      transformData: "",
      showContractEvents: false,
      showContractResults: false,
      info: {
        result: "tesSUCCESS",
      },
    };
  },
  created() {
    this.transactions();
  },
  mounted() {},
  computed: {},
  watch: {
    "$route.query.hash"() {
      this.transactions();
    },
  },
  methods: {
    transactions() {
      this.loading = true;
      this.$axios(`${api.transactionDetail}?hash=${this.$route.query.hash}`)
        .then((res) => {
          this.info = res.data;
          this.info["time"] = dayjs(res.data.time).format(
            "YYYY-MM-DD HH:mm:ss"
          );
          if (res.data.type.indexOf("Contract") > -1) {
            this.isContract = true;
            if (this.info.simple_memos && this.info.simple_memos.length > 0) {
              this.info.codeType = this.info.simple_memos[0].memo_type;
              this.info.codeVersion = this.info.simple_memos[0].memo_format;
            }
          }
          if (this.info.codeAddress) {
            this.info.codeAddressStr =
              this.info.codeAddress.substring(0, 20) +
              "..." +
              this.info.codeAddress.substring(40);
          }
          if (res.data.type == "ContractUpload") {
            this.showMemoSelect = false;
            this.memoTitle = this.$t("hash.contractCode");
          } else if (res.data.type == "ContractDeploy") {
            this.showMemoSelect = false;
            this.memoTitle = this.$t("hash.contractArg");
            if (
              this.info.contractEvents &&
              this.info.contractEvents.length > 0
            ) {
              this.showContractEvents = true;
              this.parseEvents(this.info.contractEvents);
            }
          } else if (res.data.type == "ContractCall") {
            if (
              this.info.contractEvents &&
              this.info.contractEvents.length > 0
            ) {
              this.showContractEvents = true;
              this.parseEvents(this.info.contractEvents);
            }
            if (
              this.info.contractResults &&
              this.info.contractResults.length > 0
            ) {
              this.showContractResults = true;
              this.parseResults(this.info.contractResults);
            }
           
            this.showMemoSelect = false;
            this.memoTitle = this.$t("hash.contractArg");
          }
           this.chooseType()
          this.loading = false;
        })
        .catch((err) => {
          this.$router.push("/err?err=hash");
        });
    },
    parseEvents(events) {
      events.forEach(ele => {
        if (ele.value) {
          if (typeof ele.value == "string") {
            try {
              let obj = JSON.parse(str);
              if (typeof obj == "object" && obj) {
                ele.value = formatJson(ele.value);
                ele.type = "json";
              }
            } catch (error) {}
          } else if (typeof ele.value == "object") {
            try {
              ele.value = formatJson(JSON.stringify(ele.value));
              ele.type = "json";
              if (Object.keys(ele.value).length == 0) {
                ele.value = "{}";
                ele.type = "string";
              }
            } catch (error) {}
          }
        } else {
          ele.value = this.$t("nothing");
        }
      });
    },
    parseResults(events) {
      events.forEach(ele => {
        if (ele.result) {
          if (typeof ele.result == "string") {
            try {
              let obj = JSON.parse(str);
              if (typeof obj == "object" && obj) {
                ele.result = formatJson(ele.result);
                ele.type = "json";
              }
            } catch (error) {}
          } else if (typeof ele.result == "object") {
            try {
              ele.result = formatJson(JSON.stringify(ele.result));
              ele.type = "json";
              if (Object.keys(ele.result).length == 0) {
                ele.result = "{}";
                ele.type = "string";
              }
            } catch (error) {}
          }
        }
      });
    },
    chooseType() {
      //智能合约格式
      if (this.isContract) {
        if (
          this.info.type == "ContractUpload"&&
          this.info.simple_memos &&
          this.info.simple_memos.length > 0 
        ) {
          this.transformData = js_beautify(
            this.info.simple_memos[0].memo_data,
            2,
            " "
          )
            .toString()
            .replace(/^(\s|\xA0)+|(\s|\xA0)+$/g, "");
        }
      }
    }
  },
};
</script>

<style lang="less" scoped>
@import "../assets/css/var.less";
.info {
  max-width: @max-width;
  min-width: @min-width;
  margin: 0 auto;
  padding: 0 15px;
  .box();
  margin: 20px 0;
  .tit {
    line-height: 40px;
    font-weight: bold;
    padding-left: 35px;
    color: #213b93;
  }
  .body {
    overflow: hidden;
    padding: 30px 0px 45px 0px;
    .flexdiv {
      display: -webkit-box;
      table {
        width: 50%;
        padding: 0px 35px;
        &:nth-child(2) {
        }
        tr {
          td {
            border-bottom: 1px solid #56505014;
            line-height: 50px;
            overflow: hidden;
            span {
              float: left;
              &:last-child {
                float: right;
              }
              &.err {
                color: #69afff;
              }
              &.value {
                color: #4b5065;
                text-align: right;
              }
            }
            textarea {
              background-color: #f8f9fb;
              border: none;
              resize: none;
              color: #4b5065;
            }
          }
          &:last-child {
            // td{border:none;}
          }
        }
      }
    }
  }
  .beizhu {
    padding: 10px 35px;
    .remark-body {
      color: #4b5065;
      width: 100%;
      padding: 20px;
      margin-top: 15px;
      background-color: #f8f9fb;
      border: none;
      resize: none;
    }
  }
  
}
.result {
  .box();
  padding: 20px;
  padding-top: 0px;
  .h3 {
    height: 50px;
    line-height: 70px;
    border-bottom: 1px solid #56505014;
    color: #213b93;
    font-weight: bold;
  }
}
.demo-breadcrumb-separator {
  font-weight: bold;
}
pre {
  white-space: pre-wrap; /* css3.0 */
  white-space: -moz-pre-wrap; /* Firefox */
  white-space: -pre-wrap; /* Opera 4-6 */
  white-space: -o-pre-wrap; /* Opera 7 */
  word-wrap: break-word; /* Internet Explorer 5.5+ */
  margin: 0;
  padding: 0;
}
</style>
